(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["br-home-posters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-br-poster-carousel]').forEach((root) => {
        if (root.dataset.brPosterInitialized === 'true') return;
        root.dataset.brPosterInitialized = 'true';

        const viewport = root.querySelector('[data-br-poster-viewport]');
        const posters = Array.from(root.querySelectorAll('[data-br-poster]'));
        const dots = Array.from(root.querySelectorAll('[data-br-poster-dot]'));
        const previous = root.querySelector('[data-br-poster-previous]');
        const next = root.querySelector('[data-br-poster-next]');
        if (!viewport || posters.length < 2) return;

        let activeIndex = 0;

        const setActive = (index) => {
          activeIndex = Math.max(0, Math.min(posters.length - 1, index));
          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === activeIndex;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };

        const goTo = (index) => {
          const targetIndex = (index + posters.length) % posters.length;
          posters[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          setActive(targetIndex);
        };

        dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.brPosterDot))));
        if (previous) previous.addEventListener('click', () => goTo(activeIndex - 1));
        if (next) next.addEventListener('click', () => goTo(activeIndex + 1));

        let scrollTimer;
        viewport.addEventListener('scroll', () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
            setActive(index);
          }, 80);
        }, { passive: true });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-native-customizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizedRoutesRoot = () => {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      return root.endsWith('/') ? root : `${root}/`;
    };

    const parseFieldConfig = (fieldNode) => {
      const script = fieldNode.querySelector('[data-br-field-config]');
      if (!script) return { value: {}, error: 'Missing advanced field configuration node.' };
      const source = script.textContent.trim();
      if (source === '' || source === 'null') return { value: {}, error: '' };
      try {
        const value = JSON.parse(source);
        if (!value || Array.isArray(value) || typeof value !== 'object') {
          return { value: {}, error: 'Advanced field configuration must be a JSON object.' };
        }
        return { value, error: '' };
      } catch (error) {
        return { value: {}, error: 'Advanced field configuration is not valid JSON.' };
      }
    };

    const parseAddonVariantReferences = (fieldNode) => {
      const script = fieldNode.querySelector('[data-br-addon-variants]');
      if (!script || script.textContent.trim() === '') return { value: [], error: '' };
      try {
        const value = JSON.parse(script.textContent);
        if (!Array.isArray(value)) return { value: [], error: 'Add-on Variant references must be a JSON array.' };
        return { value, error: '' };
      } catch (error) {
        return { value: [], error: 'Add-on Variant references are not valid JSON.' };
      }
    };

    const parsePaidOptions = (fieldNode) => {
      const script = fieldNode.querySelector('[data-br-paid-options]');
      if (!script || script.textContent.trim() === '') return { value: [], error: '' };
      try {
        const value = JSON.parse(script.textContent);
        if (!Array.isArray(value)) return { value: [], error: 'Paid option configuration must be a JSON array.' };
        return { value, error: '' };
      } catch (error) {
        return { value: [], error: 'Paid option configuration is not valid JSON.' };
      }
    };

    const asArray = (value) => {
      if (Array.isArray(value)) return value.map((item) => String(item));
      if (value === null || value === undefined || value === '') return [];
      return [String(value)];
    };

    const normalizeVariantId = (value) => {
      const raw = String(value || '');
      const id = raw.includes('/') ? raw.split('/').pop() : raw;
      return /^\d+$/.test(id) ? Number(id) : null;
    };

    const isStablePaidOptionKey = (value) => /^[a-f0-9]{10}$/.test(String(value || ''));

    const initialize = () => {
      document.querySelectorAll('[data-br-native-customizer]').forEach((root) => {
        if (root.dataset.brInitialized === 'true') return;

        const ownerSectionId = root.dataset.brOwnerSectionId || '';
        const ownerSection = (ownerSectionId && document.getElementById(ownerSectionId)) || root.closest('.shopify-section');
        const productId = root.dataset.productId;
        const variantMapNode = root.querySelector('[data-br-variant-map]');
        let variantMap = {};
        if (variantMapNode) {
          try { variantMap = JSON.parse(variantMapNode.textContent); }
          catch (error) { variantMap = {}; }
        }
        const formMatchesProduct = (candidate) => {
          const productInput = candidate.querySelector('input[name="product-id"]');
          if (productInput && productInput.value === productId) return true;
          const variantInput = candidate.querySelector('[name="id"]');
          return Boolean(variantInput && Object.prototype.hasOwnProperty.call(variantMap, String(variantInput.value)));
        };
        const findMatchingForms = () => Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(formMatchesProduct);
        const findPrimaryForm = () => {
          const candidates = findMatchingForms();
          const mainProductCandidates = candidates.filter((candidate) => (
            candidate.closest('.product-info')
            && candidate.closest('product-rerender')
            && !candidate.closest('dialog, [role="dialog"], quick-buy-modal, quick-buy-drawer, [data-quick-buy]')
          ));
          return mainProductCandidates.find((candidate) => candidate.querySelector('buy-buttons'))
            || mainProductCandidates[0]
            || (candidates.length === 1 ? candidates[0] : null);
        };
        let form = findPrimaryForm();
        if (!form) {
          const retryCount = Number(root.dataset.brRetryCount || '0');
          if (retryCount < 120) {
            root.dataset.brRetryCount = String(retryCount + 1);
            window.setTimeout(initialize, 250);
          }
          if (!root.brFormObserver && document.body) {
            root.brFormObserver = new MutationObserver(initialize);
            root.brFormObserver.observe(document.body, { childList: true, subtree: true });
          }
          return;
        }
        if (root.brFormObserver) {
          root.brFormObserver.disconnect();
          delete root.brFormObserver;
        }
        root.dataset.brInitialized = 'true';

        const lifecycleAbortController = new AbortController();
        const lifecycleSignal = lifecycleAbortController.signal;
        root.brLifecycleAbortController = lifecycleAbortController;
        let productInfo = form.closest('.product-info');
        let mainSection = productInfo ? productInfo.closest('.shopify-section') : form.closest('.shopify-section');
        const replacesLegacyOptions = root.dataset.replacesLegacyOptions === 'true';
        const configurationMissing = root.dataset.configurationMissing === 'true';
        const paidConfigurationIncomplete = root.dataset.paidConfigurationIncomplete === 'true';
        const customizerState = root.dataset.customizerState || 'unmanaged';
        const addonEnforcement = String(root.dataset.addonEnforcement || '').trim();
        const noFieldsRequired = customizerState === 'no_fields';
        const recoveryColorField = root.querySelector('[data-br-photo-recovery-color]');
        if (root.dataset.productHandle === 'custom-memory-photo-coin-pendant' && recoveryColorField) {
          recoveryColorField.hidden = true;
          recoveryColorField.dataset.brStaticHidden = 'true';
          recoveryColorField.querySelectorAll('input, select, textarea').forEach((control) => {
            control.disabled = true;
            control.required = false;
          });
        }
        let legacyGpoScope = productInfo || form;
        let enforceConfiguredFormState = () => {};
        if (replacesLegacyOptions) {
          const disableLegacyGpo = () => {
            legacyGpoScope.querySelectorAll('.gpo-app, .gpo-hidden-inputs').forEach((container) => {
              container.hidden = true;
              container.setAttribute('aria-hidden', 'true');
              container.querySelectorAll('input, select, textarea, button').forEach((control) => {
                control.required = false;
                control.disabled = true;
                control.removeAttribute('form');
              });
            });
            legacyGpoScope.querySelectorAll('[name="properties[_has_gpo]"]').forEach((control) => {
              control.required = false;
              control.disabled = true;
              control.removeAttribute('form');
            });
          };
          const disableAcceleratedCheckout = () => {
            if (noFieldsRequired) return;
            [legacyGpoScope, ...findMatchingForms()].forEach((scope) => {
              scope.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach((container) => {
                container.hidden = true;
                container.setAttribute('aria-hidden', 'true');
                container.querySelectorAll('button, input').forEach((control) => { control.disabled = true; });
              });
            });
          };
          const disableBypassForms = () => {
            if (noFieldsRequired) return;
            findMatchingForms().filter((candidate) => candidate !== form).forEach((candidate) => {
              candidate.dataset.brCustomizerBypassBlocked = 'true';
              candidate.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"]').forEach((control) => {
                control.disabled = true;
                control.hidden = true;
              });
            });
          };
          enforceConfiguredFormState = () => {
            form.dataset.brReplacesLegacyOptions = 'true';
            if (productInfo) productInfo.dataset.brReplacesLegacyOptions = 'true';
            disableLegacyGpo();
            disableAcceleratedCheckout();
            disableBypassForms();
          };
          enforceConfiguredFormState();
          const legacyObserver = new MutationObserver(enforceConfiguredFormState);
          legacyObserver.observe(legacyGpoScope, { childList: true, subtree: true });
          root.brLegacyObserver = legacyObserver;
        }

        const ensureStableMount = () => {
          const activeForm = findPrimaryForm();
          if (!activeForm) return false;
          form = activeForm;
          form.enctype = 'multipart/form-data';
          productInfo = form.closest('.product-info');
          mainSection = productInfo ? productInfo.closest('.shopify-section') : form.closest('.shopify-section');
          legacyGpoScope = productInfo || form;

          if (!noFieldsRequired && productInfo) {
            const variantPicker = productInfo.querySelector('.product-info__variant-picker');
            const variantBlock = variantPicker ? variantPicker.closest('[data-block-type="variant-picker"]') : null;
            let configurator = productInfo.querySelector('[data-br-product-configurator]');
            if (variantBlock && configurator && variantBlock.contains(configurator)) {
              const legacyParent = variantBlock.parentElement;
              const legacyPicker = configurator.querySelector('.product-info__variant-picker');
              if (legacyPicker) variantBlock.appendChild(legacyPicker);
              if (legacyParent) legacyParent.insertBefore(configurator, variantBlock);
            }
            if (variantBlock && !configurator) {
              configurator = document.createElement('div');
              configurator.className = 'br-product-configurator';
              configurator.setAttribute('data-br-product-configurator', '');
              const configuratorHeader = document.createElement('div');
              configuratorHeader.className = 'br-product-configurator__header';
              const heading = document.createElement('strong');
              heading.textContent = root.dataset.configureHeading || 'Configure Your Piece';
              const intro = document.createElement('span');
              intro.textContent = root.dataset.configureIntro || 'Choose product options first, then complete the personalization details.';
              configuratorHeader.append(heading, intro);
              variantBlock.parentElement.insertBefore(configurator, variantBlock);
              configurator.append(configuratorHeader, variantBlock, root);
            } else if (variantBlock && configurator) {
              if (variantBlock.parentElement !== configurator) {
                const referenceNode = root.parentElement === configurator ? root : null;
                configurator.insertBefore(variantBlock, referenceNode);
              }
              if (root.parentElement !== configurator) configurator.appendChild(root);
            } else {
              const actionStack = Array.from(form.children).find((child) => child.classList.contains('v-stack'));
              if (actionStack) {
                if (root.parentElement !== form || root.nextElementSibling !== actionStack) {
                  form.insertBefore(root, actionStack);
                }
              } else if (root.parentElement !== form || root !== form.lastElementChild) {
                form.appendChild(root);
              }
            }
            const currentVariantPicker = productInfo.querySelector('.product-info__variant-picker');
            if (currentVariantPicker) currentVariantPicker.classList.add('br-product-configurator__native');
          }

          const formId = form.getAttribute('id');
          root.querySelectorAll('input, select, textarea, button').forEach((field) => {
            if (formId) field.setAttribute('form', formId);
            else field.removeAttribute('form');
          });
          enforceConfiguredFormState();
          return true;
        };

        ensureStableMount();
        root.hidden = noFieldsRequired;

        const actionError = root.querySelector('[data-br-action-error]');
        const purchaseButtons = () => Array.from((findPrimaryForm() || form).querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"]'));
        let hardBlockReason = configurationMissing
          ? 'This product is missing its required BornReal customization configuration. Please contact us before ordering.'
          : (paidConfigurationIncomplete
            ? 'This product has BornReal customization fields, but one or more paid options are not yet mapped to real Shopify add-on variants. Please contact us before ordering.'
            : '');
        let submissionInProgress = false;
        let paidPricingPending = false;

        const showActionError = (message) => {
          if (!actionError) return;
          const nextMessage = String(message || '');
          const nextHidden = nextMessage === '';
          if (actionError.textContent !== nextMessage) actionError.textContent = nextMessage;
          if (actionError.hidden !== nextHidden) actionError.hidden = nextHidden;
        };

        const enforceHardBlock = () => {
          const gated = Boolean(hardBlockReason) || paidPricingPending;
          purchaseButtons().forEach((button) => {
            if (gated) {
              if (button.dataset.brPricingGate !== 'true') {
                button.dataset.brPricingWasDisabled = String(button.disabled);
              }
              button.disabled = true;
              button.setAttribute('aria-disabled', 'true');
              button.dataset.brPricingGate = 'true';
              if (hardBlockReason) button.dataset.brHardBlocked = 'true';
            } else if (button.dataset.brPricingGate === 'true') {
              button.disabled = button.dataset.brPricingWasDisabled === 'true';
              if (!button.disabled) button.removeAttribute('aria-disabled');
              delete button.dataset.brPricingWasDisabled;
              delete button.dataset.brPricingGate;
            }
          });
          if (root.querySelector('[data-br-configuration-error]')) return;
          if (hardBlockReason) showActionError(hardBlockReason);
          else if (paidPricingPending) showActionError('Loading live upgrade prices…');
        };

        const setBusy = (busy) => {
          submissionInProgress = busy;
          purchaseButtons().forEach((button) => {
            if (busy) {
              button.dataset.brWasDisabled = String(button.disabled);
              button.disabled = true;
              button.setAttribute('aria-busy', 'true');
            } else {
              const wasDisabled = button.dataset.brWasDisabled === 'true';
              button.disabled = wasDisabled || button.dataset.brHardBlocked === 'true';
              button.removeAttribute('aria-busy');
              delete button.dataset.brWasDisabled;
            }
          });
        };

        const panels = Array.from(root.querySelectorAll('[data-br-panel]'));
        const routeInputs = Array.from(root.querySelectorAll('[data-br-route]'));
        const fixedRoute = root.querySelector('[data-br-fixed-route]');
        const conditionalVariantFields = Array.from(root.querySelectorAll('[data-br-variant-required-match]'));
        const configuredFieldNodes = Array.from(root.querySelectorAll('[data-br-configured-field]'));
        const configuredFields = configuredFieldNodes.map((node) => {
          const parsed = parseFieldConfig(node);
          if (parsed.error && !hardBlockReason) hardBlockReason = parsed.error;
          const references = parseAddonVariantReferences(node);
          if (references.error && !hardBlockReason) hardBlockReason = references.error;
          const paidOptions = parsePaidOptions(node);
          if (paidOptions.error && !hardBlockReason) hardBlockReason = paidOptions.error;
          return {
            node,
            config: parsed.value,
            addonVariantReferences: references.value,
            paidOptions: paidOptions.value,
            paidMappings: new Map()
          };
        });

        const duplicatePropertyKeys = configuredFieldNodes
          .map((node) => node.dataset.brPropertyKey)
          .filter((key, index, keys) => key && keys.indexOf(key) !== index);
        if (duplicatePropertyKeys.length && !hardBlockReason) {
          hardBlockReason = `Duplicate customization property: ${duplicatePropertyKeys[0]}.`;
        }

        const customizationControls = Array.from(root.querySelectorAll('input, select, textarea'));
        const controllerState = {
          currentVariantId: '',
          currentVariantTitle: '',
          values: Object.create(null),
          files: Object.create(null),
          visibility: Object.create(null)
        };
        root.brCustomizerState = controllerState;

        const controlStateKey = (control, index) => {
          const fieldNode = control.closest('[data-br-configured-field]');
          const fieldKey = fieldNode
            ? fieldNode.dataset.brFieldHandle || fieldNode.dataset.brPropertyKey
            : control.name || control.id || 'customization-control';
          const choiceValue = control.type === 'checkbox' || control.type === 'radio' ? control.value : '';
          return `${fieldKey}::${control.type || control.tagName.toLowerCase()}::${choiceValue}::${index}`;
        };

        const updateVariantState = (variantId) => {
          const normalizedId = normalizeVariantId(variantId);
          controllerState.currentVariantId = normalizedId === null ? '' : String(normalizedId);
          controllerState.currentVariantTitle = controllerState.currentVariantId
            ? variantMap[controllerState.currentVariantId] || ''
            : '';
          root.dataset.brCurrentVariantId = controllerState.currentVariantId;
        };

        const updateVariantStateFromForm = (candidate = form) => {
          const variantInput = candidate ? candidate.querySelector('[name="id"]') : null;
          updateVariantState(variantInput ? variantInput.value : '');
        };

        const captureCustomizationState = () => {
          customizationControls.forEach((control, index) => {
            const key = controlStateKey(control, index);
            if (control.type === 'file') {
              controllerState.files[key] = Array.from(control.files || []);
            } else if (control.type === 'checkbox' || control.type === 'radio') {
              controllerState.values[key] = control.checked;
            } else {
              controllerState.values[key] = control.value;
            }
          });
        };

        const restoreCustomizationState = () => {
          customizationControls.forEach((control, index) => {
            if (control.type === 'file') return;
            const key = controlStateKey(control, index);
            if (!Object.prototype.hasOwnProperty.call(controllerState.values, key)) return;
            if (control.type === 'checkbox' || control.type === 'radio') {
              control.checked = controllerState.values[key] === true;
            } else {
              control.value = controllerState.values[key];
            }
          });
        };

        updateVariantStateFromForm();

        const valueForField = (fieldNode) => {
          const checkboxOptions = Array.from(fieldNode.querySelectorAll('[data-br-checkbox-option]'));
          if (checkboxOptions.length) return checkboxOptions.filter((input) => input.checked).map((input) => input.value);
          const selectOutput = fieldNode.querySelector('[data-br-select-output]');
          if (selectOutput) return selectOutput.value;
          const checkedRadio = fieldNode.querySelector('input[type="radio"]:checked');
          if (checkedRadio) return checkedRadio.value;
          const checkbox = fieldNode.querySelector('input[type="checkbox"]:not([data-br-checkbox-option])');
          if (checkbox) return checkbox.checked ? checkbox.value : '';
          const control = fieldNode.querySelector('input[name], select[name], textarea[name]');
          return control ? control.value : '';
        };

        const fieldForSource = (source) => configuredFieldNodes.find((node) => (
          node.dataset.brFieldHandle === source || node.dataset.brPropertyKey === source
        ));

        const valueForSource = (source) => {
          if (source === '$variant_id') return controllerState.currentVariantId;
          if (source === '$variant_title') return controllerState.currentVariantTitle;
          const sourceField = fieldForSource(source);
          return sourceField ? valueForField(sourceField) : '';
        };

        const conditionMatches = (condition) => {
          if (!condition) return true;
          const sourceValue = valueForSource(String(condition.source || condition.field || ''));
          const sourceValues = Array.isArray(sourceValue) ? sourceValue.map(String) : [String(sourceValue || '')];
          const expectedValues = asArray(condition.values !== undefined ? condition.values : condition.value);
          const operator = String(condition.operator || 'equals');
          if (operator === 'empty') return sourceValues.every((value) => value === '');
          if (operator === 'not_empty') return sourceValues.some((value) => value !== '');
          if (operator === 'checked') return sourceValues.some((value) => value !== '');
          if (operator === 'unchecked') return sourceValues.every((value) => value === '');
          if (operator === 'equals' || operator === 'in') return sourceValues.some((value) => expectedValues.includes(value));
          if (operator === 'not_equals' || operator === 'not_in') return sourceValues.every((value) => !expectedValues.includes(value));
          if (operator === 'contains') return sourceValues.some((value) => expectedValues.some((expected) => value.includes(expected)));
          if (operator === 'not_contains') return sourceValues.every((value) => expectedValues.every((expected) => !value.includes(expected)));
          return false;
        };

        const applyDefault = ({ node, config }) => {
          if (!Object.prototype.hasOwnProperty.call(config, 'default_value')) return;
          const defaultValue = config.default_value;
          const checkboxOptions = Array.from(node.querySelectorAll('[data-br-checkbox-option]'));
          if (checkboxOptions.length) {
            const defaults = asArray(defaultValue);
            checkboxOptions.forEach((input) => { input.checked = defaults.includes(input.value); });
            return;
          }
          const checkbox = node.querySelector('input[type="checkbox"]');
          if (checkbox) {
            checkbox.checked = defaultValue === true || defaultValue === checkbox.value || String(defaultValue).toLowerCase() === 'true';
            return;
          }
          const radios = Array.from(node.querySelectorAll('input[type="radio"]'));
          if (radios.length) {
            radios.forEach((input) => { input.checked = String(defaultValue) === input.value; });
            return;
          }
          const control = node.querySelector('input[name], select[name], textarea[name]');
          if (control && control.type !== 'file' && control.value === '') control.value = String(defaultValue ?? '');
        };

        const updateGroupedFields = () => {
          configuredFields.forEach(({ node, config }) => {
            const active = !node.hidden;
            const required = node.dataset.brBaseRequired === 'true';
            const selectOptions = Array.from(node.querySelectorAll('[data-br-select-option]'));
            const selectOutput = node.querySelector('[data-br-select-output]');
            if (selectOptions.length && selectOutput) {
              const selectedOption = selectOptions.find((input) => input.checked && !input.disabled);
              selectOutput.value = selectedOption ? selectedOption.value : '';
              selectOptions.forEach((input) => input.setCustomValidity(''));
              if (active && required && !selectedOption) selectOptions[0].setCustomValidity('Select one option.');
            }
            const checkboxOptions = Array.from(node.querySelectorAll('[data-br-checkbox-option]'));
            const checkboxOutput = node.querySelector('[data-br-checkbox-output]');
            if (checkboxOptions.length && checkboxOutput) {
              const selected = checkboxOptions.filter((input) => input.checked).map((input) => input.value);
              const configuredMinimum = Number(config.min_value);
              const configuredMaximum = Number(config.max_value);
              const minimum = Number.isInteger(configuredMinimum) && configuredMinimum >= 0
                ? configuredMinimum
                : (required ? 1 : 0);
              const maximum = Number.isInteger(configuredMaximum) && configuredMaximum >= minimum
                ? configuredMaximum
                : checkboxOptions.length;
              checkboxOutput.value = selected.join(', ');
              checkboxOptions.forEach((input) => input.setCustomValidity(''));
              if (active && selected.length < minimum) {
                checkboxOptions[0].setCustomValidity(`Select at least ${minimum} option${minimum === 1 ? '' : 's'}.`);
              } else if (active && selected.length > maximum) {
                checkboxOptions[0].setCustomValidity(`Select no more than ${maximum} option${maximum === 1 ? '' : 's'}.`);
              }
            }
            const fileInputs = Array.from(node.querySelectorAll('[data-br-file-input]'));
            if (fileInputs.length) {
              fileInputs.forEach((input) => input.setCustomValidity(''));
              const hasFile = fileInputs.some((input) => input.files && input.files.length > 0);
              if (active && required && !hasFile) fileInputs[0].setCustomValidity('Upload at least one file.');
            }
          });
        };

        const applyConfiguredConditions = () => {
          for (let pass = 0; pass < Math.max(1, configuredFields.length); pass += 1) {
            configuredFields.forEach(({ node, config }) => {
              const active = conditionMatches(config.condition) && node.dataset.brStaticHidden !== 'true';
              node.hidden = !active || node.dataset.brFieldType === 'hidden';
              node.dataset.brConditionActive = String(active);
              const fieldKey = node.dataset.brFieldHandle || node.dataset.brPropertyKey;
              if (fieldKey) controllerState.visibility[fieldKey] = active;
              node.querySelectorAll('input, select, textarea').forEach((control) => {
                control.disabled = !active;
                const grouped = control.hasAttribute('data-br-checkbox-option')
                  || control.hasAttribute('data-br-select-option')
                  || control.hasAttribute('data-br-file-input');
                control.required = active && !grouped && node.dataset.brBaseRequired === 'true' && control.type !== 'hidden';
              });
            });
          }
          updateGroupedFields();
        };

        configuredFields.forEach(applyDefault);
        captureCustomizationState();

        const supportedConditionOperators = new Set(['empty', 'not_empty', 'checked', 'unchecked', 'equals', 'in', 'not_equals', 'not_in', 'contains', 'not_contains']);
        configuredFields.forEach(({ config }) => {
          if (!config.condition || hardBlockReason) return;
          const source = String(config.condition.source || config.condition.field || '');
          const operator = String(config.condition.operator || 'equals');
          if (!source || (!source.startsWith('$variant_') && !fieldForSource(source))) {
            hardBlockReason = `A conditional customization field references an unknown source: ${source || '(empty)'}.`;
          } else if (!supportedConditionOperators.has(operator)) {
            hardBlockReason = `Unsupported customization condition operator: ${operator}.`;
          }
        });

        const addOnDeclarations = configuredFields.filter(({ config, paidOptions }) => (
          paidOptions.length > 0 || config.add_on || config.addon
        ));
        const registeredPaidOptionKeys = new Set();
        addOnDeclarations.forEach((field) => {
          if (hardBlockReason) return;
          const { config, paidOptions, addonVariantReferences, paidMappings } = field;
          const declaration = config.add_on || config.addon;
          const legacyVariants = declaration && (declaration.variants || declaration.variant_map);
          const directOptionEntries = paidOptions.map((entry) => [String(entry.value || ''), entry]);
          const directOptions = new Map(directOptionEntries);
          if (paidOptions.length > 0 && (
            directOptionEntries.some(([value]) => !value)
            || directOptions.size !== directOptionEntries.length
          )) {
            hardBlockReason = 'A paid customization field contains a blank or duplicate option value.';
            return;
          }
          const variants = directOptions.size > 0
            ? Object.fromEntries(directOptions)
            : legacyVariants;
          if (!variants || typeof variants !== 'object') {
            hardBlockReason = 'A paid customization option is missing its trusted add-on variant map.';
            return;
          }
          const chargeMode = String((declaration && declaration.charge_mode) || 'default');
          const selectionBilling = String((declaration && declaration.selection_billing) || 'per_selected_value');
          if (!['default', 'one_time_charge'].includes(chargeMode) || selectionBilling !== 'per_selected_value') {
            hardBlockReason = 'A paid customization option uses a billing rule that requires merchant review.';
            return;
          }
          const legacyRequiredValues = [
            ...asArray(declaration && declaration.required_for),
            ...Object.keys(legacyVariants && typeof legacyVariants === 'object' ? legacyVariants : {})
          ];
          const requiredFor = Array.from(new Set([
            ...legacyRequiredValues,
            ...Array.from(directOptions.keys())
          ].filter(Boolean)));
          const missingRequiredMap = requiredFor.find((value) => value !== '*' && variants[value] === undefined);
          if (missingRequiredMap) {
            hardBlockReason = `Paid option "${missingRequiredMap}" is missing its add-on variant.`;
            return;
          }
          const referencedById = new Map(addonVariantReferences.map((entry) => [
            normalizeVariantId(entry.variant_id),
            entry
          ]));
          Object.entries(variants).forEach(([value, rawEntry]) => {
            if (hardBlockReason) return;
            const entry = rawEntry && typeof rawEntry === 'object' ? rawEntry : { variant_id: rawEntry };
            const rawId = entry && typeof entry === 'object' ? (entry.variant_id || entry.id) : entry;
            const variantId = normalizeVariantId(rawId);
            if (variantId === null) {
              hardBlockReason = `Paid option "${value}" is missing its add-on Variant reference.`;
              return;
            }
            const status = String(entry.status || 'ACTIVE').toUpperCase();
            if (entry.failClosed === true || !['ACTIVE', 'REFERENCE'].includes(status)) {
              hardBlockReason = `Paid option "${value}" contains an unavailable add-on Variant.`;
              return;
            }
            const optionKey = String(entry.option_key || entry.paid_option_key || entry.paid_option_token || '').trim();
            if (!isStablePaidOptionKey(optionKey)) {
              hardBlockReason = `Paid option "${value}" is missing its stable canonical option key.`;
              return;
            }
            if (registeredPaidOptionKeys.has(optionKey)) {
              hardBlockReason = `Paid option "${value}" reuses a canonical option key.`;
              return;
            }
            const reference = directOptions.has(value) ? entry : referencedById.get(variantId);
            const quantity = Number(entry.quantity ?? 1);
            const quantityMode = String(entry.quantity_mode || (chargeMode === 'one_time_charge' ? 'one_per_parent_line' : 'per_parent_quantity'));
            if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100) {
              hardBlockReason = `Paid option "${value}" has an invalid quantity.`;
              return;
            }
            if (!['per_parent_quantity', 'one_per_parent_line'].includes(quantityMode)) {
              hardBlockReason = `Paid option "${value}" has an unsupported quantity mode.`;
              return;
            }
            const referencePrice = reference && Number(reference.price_cents);
            const productHandle = String(entry.product_handle || '');
            if (reference && reference.available === false) {
              hardBlockReason = `Paid option "${value}" is sold out or unavailable in Shopify.`;
              return;
            }
            if ((!Number.isFinite(referencePrice) || referencePrice < 0) && !productHandle) {
              hardBlockReason = `Paid option "${value}" has no live Shopify Variant price source.`;
              return;
            }
            registeredPaidOptionKeys.add(optionKey);
            paidMappings.set(value, {
              optionKey,
              value,
              label: directOptions.has(value) || entry.label ? String(entry.label || value) : '',
              variantId,
              quantity,
              quantityMode,
              applicableVariantIds: asArray(entry.applicable_variant_ids || (declaration && declaration.applicable_variant_ids))
                .map(normalizeVariantId)
                .filter((id) => id !== null),
              visibilityRules: entry.visibility_rules || null,
              productHandle,
              priceCents: Number.isFinite(referencePrice) ? referencePrice : null,
              priceDisplay: String((reference && reference.price_display) || ''),
              available: reference ? reference.available !== false : null,
              priceSource: reference ? 'variant_reference' : 'product_ajax'
            });
          });
        });

        const hasValidPaidOptionMappings = addOnDeclarations.some(({ paidMappings }) => paidMappings.size > 0);
        if (!hardBlockReason && hasValidPaidOptionMappings && addonEnforcement !== 'shopify-function-v1') {
          hardBlockReason = 'Paid customization is temporarily unavailable because secure checkout validation is not enabled. Please contact us before ordering.';
          root.dataset.brAddonEnforcementBlocked = 'true';
        }

        const paidTotal = root.querySelector('[data-br-paid-total]');
        const paidTotalValue = root.querySelector('[data-br-paid-total-value]');
        const currencyCode = root.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        const formatVariantPrice = (priceCents) => {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: currencyCode
            }).format(Number(priceCents) / 100);
          } catch (error) {
            return `${currencyCode} ${(Number(priceCents) / 100).toFixed(2)}`;
          }
        };

        const mappingAppliesToCurrentVariant = (mapping) => {
          if (mapping.applicableVariantIds.length > 0) {
            const currentId = normalizeVariantId(controllerState.currentVariantId);
            if (currentId === null || !mapping.applicableVariantIds.includes(currentId)) return false;
          }
          return !mapping.visibilityRules || conditionMatches(mapping.visibilityRules);
        };

        const renderPaidOptionPrices = () => {
          addOnDeclarations.forEach(({ node, paidMappings }) => {
            paidMappings.forEach((mapping, value) => {
              const display = mapping.priceDisplay || (Number.isFinite(mapping.priceCents) ? formatVariantPrice(mapping.priceCents) : '');
              node.querySelectorAll('[data-br-option-label], [data-br-option-price], option[data-br-option-value]').forEach((labelNode) => {
                if (labelNode.dataset.brOptionValue !== value) return;
                if (labelNode.hasAttribute('data-br-option-price')) {
                  const nextPrice = display ? ` (+${display})` : '';
                  if (labelNode.textContent !== nextPrice) labelNode.textContent = nextPrice;
                  return;
                }
                if (!labelNode.dataset.brBaseLabel) labelNode.dataset.brBaseLabel = mapping.label || labelNode.textContent.trim();
                const nextLabel = display ? `${labelNode.dataset.brBaseLabel} (+${display})` : labelNode.dataset.brBaseLabel;
                if (labelNode.textContent !== nextLabel) labelNode.textContent = nextLabel;
              });
            });
          });
        };

        let publishPaidAddOns = () => {};
        const updatePaidOptionState = () => {
          let selectedTotal = 0;
          const requestedQuantity = Number.parseInt(String((form && form.elements.quantity && form.elements.quantity.value) || '1'), 10);
          const parentQuantity = Number.isInteger(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
          addOnDeclarations.forEach(({ node, paidMappings }) => {
            const fieldActive = node.dataset.brConditionActive !== 'false';
            paidMappings.forEach((mapping, value) => {
              const applicable = fieldActive && mappingAppliesToCurrentVariant(mapping) && mapping.available !== false;
              node.querySelectorAll('option[data-br-option-value], input[data-br-option-value]').forEach((control) => {
                if (control.dataset.brOptionValue !== value) return;
                control.disabled = !applicable;
                if (control.tagName === 'OPTION') control.hidden = !applicable;
                else if (control.closest('label')) control.closest('label').hidden = !applicable;
                if (!applicable && control.tagName === 'OPTION' && control.selected) control.selected = false;
                if (!applicable && (control.type === 'checkbox' || control.type === 'radio')) control.checked = false;
              });
            });
            const selectedValues = asArray(valueForField(node)).filter(Boolean);
            selectedValues.forEach((value) => {
              const mapping = paidMappings.get(value);
              if (!mapping || !mappingAppliesToCurrentVariant(mapping) || !Number.isFinite(mapping.priceCents)) return;
              const multiplier = mapping.quantityMode === 'one_per_parent_line' ? mapping.quantity : mapping.quantity * parentQuantity;
              selectedTotal += mapping.priceCents * multiplier;
            });
          });
          updateGroupedFields();
          if (paidTotal && paidTotalValue) {
            paidTotal.hidden = selectedTotal === 0;
            const nextTotal = selectedTotal === 0 ? '' : `+${formatVariantPrice(selectedTotal)}`;
            if (paidTotalValue.textContent !== nextTotal) paidTotalValue.textContent = nextTotal;
          }
          publishPaidAddOns();
        };

        const hydratePaidOptionPrices = async () => {
          const ajaxMappings = addOnDeclarations.flatMap(({ paidMappings }) => (
            Array.from(paidMappings.values()).filter((mapping) => mapping.priceSource === 'product_ajax')
          ));
          if (!ajaxMappings.length) {
            renderPaidOptionPrices();
            updatePaidOptionState();
            return;
          }
          const productRequests = new Map();
          ajaxMappings.forEach((mapping) => {
            if (!productRequests.has(mapping.productHandle)) {
              productRequests.set(mapping.productHandle, fetch(`${normalizedRoutesRoot()}products/${encodeURIComponent(mapping.productHandle)}.js`, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
              }).then(async (response) => {
                if (!response.ok) throw new Error(`Shopify could not load paid option merchandise: ${mapping.productHandle}.`);
                return response.json();
              }));
            }
          });
          const products = new Map();
          await Promise.all(Array.from(productRequests.entries()).map(async ([handle, request]) => {
            products.set(handle, await request);
          }));
          ajaxMappings.forEach((mapping) => {
            const product = products.get(mapping.productHandle);
            const liveVariant = product && Array.isArray(product.variants)
              ? product.variants.find((variant) => normalizeVariantId(variant.id) === mapping.variantId)
              : null;
            if (!liveVariant || liveVariant.available === false || !Number.isFinite(Number(liveVariant.price))) {
              throw new Error(`Paid option "${mapping.value}" is unavailable in Shopify.`);
            }
            mapping.priceCents = Number(liveVariant.price);
            mapping.priceDisplay = formatVariantPrice(mapping.priceCents);
            mapping.available = true;
          });
          renderPaidOptionPrices();
          updatePaidOptionState();
        };

        const updateConditionalVariantFields = () => {
          conditionalVariantFields.forEach((field) => {
            const match = field.dataset.brVariantRequiredMatch || '';
            field.required = !field.disabled && match !== '' && controllerState.currentVariantTitle.toLowerCase().includes(match.toLowerCase());
          });
        };

        const activateRoute = (route) => {
          panels.forEach((panel) => {
            const active = panel.dataset.brPanel === route;
            panel.hidden = !active;
            panel.querySelectorAll('input, select, textarea').forEach((field) => {
              field.disabled = !active;
              if (field.hasAttribute('data-br-required')) field.required = active;
            });
          });
        };

        routeInputs.forEach((input) => {
          input.addEventListener('change', () => {
            activateRoute(input.dataset.brRoute);
            updateConditionalVariantFields();
          }, { signal: lifecycleSignal });
        });
        if (fixedRoute) activateRoute(fixedRoute.dataset.brFixedRoute);
        else activateRoute('');
        updateConditionalVariantFields();
        applyConfiguredConditions();
        updatePaidOptionState();
        captureCustomizationState();

        if (addOnDeclarations.length > 0 && !hardBlockReason) {
          paidPricingPending = addOnDeclarations.some(({ paidMappings }) => (
            Array.from(paidMappings.values()).some((mapping) => mapping.priceSource === 'product_ajax')
          ));
          enforceHardBlock();
          hydratePaidOptionPrices()
            .catch((error) => { hardBlockReason = error.message; })
            .finally(() => {
              paidPricingPending = false;
              if (!hardBlockReason) showActionError('');
              enforceHardBlock();
              publishPaidAddOns();
            });
        } else {
          renderPaidOptionPrices();
          updatePaidOptionState();
        }

        let scheduleEnvironmentSync = () => {};
        const handleFormChange = (event) => {
          if (event.target && event.target.name === 'id') updateVariantState(event.target.value);
          else updateVariantStateFromForm(form);
          restoreCustomizationState();
          updateConditionalVariantFields();
          applyConfiguredConditions();
          updatePaidOptionState();
          enforceHardBlock();
          scheduleEnvironmentSync();
        };
        const handleVariantChange = (event) => {
          if (event.detail && event.detail.variant) updateVariantState(event.detail.variant.id);
          else updateVariantStateFromForm(form);
          restoreCustomizationState();
          updateConditionalVariantFields();
          applyConfiguredConditions();
          updatePaidOptionState();
          enforceHardBlock();
          scheduleEnvironmentSync();
        };
        const handleCustomizationStateChange = (event) => {
          if (event.target && event.target.hasAttribute('data-br-select-option') && event.target.checked) {
            const group = event.target.closest('[data-br-select-button-group]');
            if (group) {
              group.querySelectorAll('[data-br-select-option]').forEach((option) => {
                if (option !== event.target) option.checked = false;
              });
            }
          }
          captureCustomizationState();
          applyConfiguredConditions();
          updatePaidOptionState();
          captureCustomizationState();
        };
        root.addEventListener('input', handleCustomizationStateChange, { signal: lifecycleSignal });
        root.addEventListener('change', handleCustomizationStateChange, { signal: lifecycleSignal });

        root.querySelectorAll('input[maxlength], textarea[maxlength]').forEach((field) => {
          const counter = field.parentElement.querySelector('[data-br-counter]');
          if (!counter) return;
          const updateCounter = () => { counter.textContent = `${field.value.length}/${field.maxLength}`; };
          field.addEventListener('input', updateCounter, { signal: lifecycleSignal });
          updateCounter();
        });

        root.querySelectorAll('[data-br-file-input]').forEach((field) => {
          const fileName = field.parentElement.querySelector('[data-br-file-name]');
          const removeButton = field.parentElement.querySelector('[data-br-file-remove]');
          if (!fileName) return;
          const updateFileName = () => {
            const hasFile = Boolean(field.files && field.files.length);
            fileName.textContent = hasFile ? field.files[0].name : root.dataset.fileEmpty;
            if (removeButton) removeButton.hidden = !hasFile;
          };
          field.addEventListener('change', updateFileName, { signal: lifecycleSignal });
          if (removeButton) {
            removeButton.addEventListener('click', () => {
              field.value = '';
              field.dispatchEvent(new Event('change', { bubbles: true }));
              field.focus();
            }, { signal: lifecycleSignal });
          }
          updateFileName();
        });

        const selectedAddOns = () => {
          const addOns = [];
          addOnDeclarations.forEach(({ node, paidMappings }) => {
            if (node.dataset.brConditionActive === 'false') return;
            const selectedValues = asArray(valueForField(node)).filter((value) => value !== '');
            selectedValues.forEach((selectedValue) => {
              const mapping = paidMappings.get(selectedValue);
              if (!mapping) return;
              if (!mappingAppliesToCurrentVariant(mapping)) return;
              if (mapping.available !== true || !Number.isFinite(mapping.priceCents)) {
                throw new Error(`Paid option "${selectedValue}" has not resolved to available Shopify merchandise.`);
              }
              addOns.push({
                optionKey: mapping.optionKey,
                variantId: mapping.variantId,
                quantity: mapping.quantity,
                quantityMode: mapping.quantityMode,
                source: node.dataset.brPropertyKey || node.dataset.brFieldHandle || 'Customization',
                value: selectedValue,
                priceCents: mapping.priceCents
              });
            });
          });
          return addOns;
        };

        publishPaidAddOns = () => {
          const productId = String(root.dataset.productId || '');
          let selected = null;
          if (!hardBlockReason && !paidPricingPending) {
            try {
              const requestedQuantity = Number.parseInt(String((form && form.elements.quantity && form.elements.quantity.value) || '1'), 10);
              const parentQuantity = Number.isInteger(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
              selected = Object.freeze(selectedAddOns().map((addOn) => Object.freeze({
                variantId: String(addOn.variantId),
                quantity: addOn.quantityMode === 'one_per_parent_line'
                  ? addOn.quantity
                  : addOn.quantity * parentQuantity
              })));
            } catch (error) {
              selected = null;
            }
          }
          root.dispatchEvent(new CustomEvent('bornreal:paid-addons-change', {
            bubbles: true,
            detail: Object.freeze({ productId, selected })
          }));
        };
        root.addEventListener('bornreal:paid-addons-request', (event) => {
          if (event.target === root) publishPaidAddOns();
        }, { signal: lifecycleSignal });
        publishPaidAddOns();

        const selectedCustomizationFiles = () => Array.from(root.querySelectorAll('[data-br-file-input]'))
          .filter((input) => !input.disabled && input.files && input.files.length > 0);

        const fetchJson = async (path, options = {}) => {
          const response = await fetch(`${normalizedRoutesRoot()}${path}`, {
            credentials: 'same-origin',
            ...options,
            headers: { Accept: 'application/json', ...(options.headers || {}) }
          });
          let payload = null;
          try { payload = await response.json(); }
          catch (error) { payload = null; }
          if (!response.ok) {
            const message = payload && (payload.description || payload.message)
              ? payload.description || payload.message
              : 'Shopify could not add this configuration to the cart.';
            throw new Error(message);
          }
          return payload;
        };

        const removeBundleFromCart = async (bundleId) => {
          try {
            const cart = await fetchJson('cart.js');
            const matchingItems = (cart.items || []).filter((item) => (
              item.properties && item.properties['_BornReal bundle'] === bundleId
            ));
            const parent = matchingItems.find((item) => item.properties['_BornReal bundle role'] === 'parent');
            if (parent) {
              await fetchJson('cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parent.key, quantity: 0 })
              });
              return;
            }
            for (const item of matchingItems) {
              await fetchJson('cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            }
          } catch (error) {
            /* Best-effort rollback. Shopify removes native nested children when the parent is removed. */
          }
        };

        const linePropertiesFromFormData = (formData) => {
          const properties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.*)\]$/);
            if (!match || typeof value !== 'string' || value === '') return;
            properties[match[1]] = value;
          });
          return properties;
        };

        const separatePaidSelectionsFromParentProperties = (formData, addOns) => {
          const paidValuesByProperty = new Map();
          addOns.forEach((addOn) => {
            if (!paidValuesByProperty.has(addOn.source)) paidValuesByProperty.set(addOn.source, new Set());
            paidValuesByProperty.get(addOn.source).add(addOn.value);
          });
          addOnDeclarations.forEach(({ node }) => {
            const propertyKey = node.dataset.brPropertyKey;
            const paidValues = paidValuesByProperty.get(propertyKey);
            if (!propertyKey || !paidValues || paidValues.size === 0) return;
            const selectedValue = valueForField(node);
            const selectedValues = asArray(selectedValue).filter((value) => value !== '');
            const freeValues = selectedValues.filter((value) => !paidValues.has(value));
            const propertyName = `properties[${propertyKey}]`;
            if (freeValues.length === 0) formData.delete(propertyName);
            else formData.set(propertyName, Array.isArray(selectedValue) ? freeValues.join(', ') : freeValues[0]);
          });
        };

        const paidManifestForAddOns = (addOns) => {
          const optionKeys = addOns.map((addOn) => String(addOn.optionKey || ''));
          if (optionKeys.some((optionKey) => !isStablePaidOptionKey(optionKey))) {
            throw new Error('A selected paid option is missing its stable canonical option key.');
          }
          if (new Set(optionKeys).size !== optionKeys.length) {
            throw new Error('A selected paid option contains a duplicate canonical option key.');
          }
          return JSON.stringify(optionKeys);
        };

        const addConfiguredBundle = async (addOns, activeForm) => {
          const formData = new FormData(activeForm);
          separatePaidSelectionsFromParentProperties(formData, addOns);
          if (hasValidPaidOptionMappings) {
            formData.set('properties[_BornReal paid manifest]', paidManifestForAddOns(addOns));
          }
          const variantId = normalizeVariantId(formData.get('id'));
          const requestedQuantity = Number.parseInt(String(formData.get('quantity') || '1'), 10);
          const quantity = Number.isInteger(requestedQuantity) && requestedQuantity > 0 ? Math.min(requestedQuantity, 1000) : 1;
          if (variantId === null) throw new Error('Select an available product variant before adding to cart.');
          if (controllerState.currentVariantId && controllerState.currentVariantId !== String(variantId)) {
            throw new Error('The selected product variant changed before it could be added. Please review the selection and try again.');
          }

          const bundleId = addOns.length
            ? (window.crypto && typeof window.crypto.randomUUID === 'function'
              ? window.crypto.randomUUID()
              : `br-${Date.now()}-${Math.random().toString(36).slice(2)}`)
            : '';
          if (bundleId) {
            formData.set('properties[_BornReal bundle]', bundleId);
            formData.set('properties[_BornReal bundle role]', 'parent');
          }
          const selectedFiles = Array.from(formData.values()).filter((value) => value instanceof File && value.size > 0);
          Array.from(formData.entries()).forEach(([key, value]) => {
            if (value instanceof File && value.size === 0) formData.delete(key);
          });

          const addOnItems = addOns.map((addOn) => {
            if (addOn.variantId === variantId) {
              throw new Error(`Paid option "${addOn.value}" cannot use the same Variant as its parent product.`);
            }
            return {
              id: addOn.variantId,
              quantity: addOn.quantityMode === 'one_per_parent_line' ? addOn.quantity : addOn.quantity * quantity,
              properties: {
                '_BornReal bundle': bundleId,
                '_BornReal bundle role': 'nested add-on',
                '_BornReal paid option key': addOn.optionKey,
                '_BornReal add-on source': addOn.source,
                '_BornReal add-on selection': addOn.value
              }
            };
          });

          const sectionsToBundle = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          }));
          const sectionRequest = {
            sections: sectionsToBundle,
            sections_url: `${normalizedRoutesRoot()}variants/${variantId}`
          };
          let responseJson = null;
          let addedItems = [];

          try {
            if (selectedFiles.length === 0) {
              const parentItem = {
                id: variantId,
                quantity,
                properties: linePropertiesFromFormData(formData)
              };
              const sellingPlan = formData.get('selling_plan');
              if (sellingPlan) parentItem.selling_plan = Number(sellingPlan);
              const nestedAddOnItems = addOnItems.map((item) => ({ ...item, parent_id: variantId }));
              responseJson = await fetchJson('cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ items: [parentItem, ...nestedAddOnItems], ...sectionRequest })
              });
              addedItems = responseJson && Array.isArray(responseJson.items) ? responseJson.items : [];
            } else if (addOnItems.length) {
              const parentResponse = await fetchJson('cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: formData
              });
              const parentItems = Array.isArray(parentResponse.items) ? parentResponse.items : [parentResponse];
              const parentLineKey = parentItems.find((item) => item && item.key)?.key;
              if (!parentLineKey) throw new Error('Shopify did not return the parent cart line for the uploaded customization.');
              addedItems.push(...parentItems);
              const nestedAddOnItems = addOnItems.map((item) => ({ ...item, parent_line_key: parentLineKey }));
              responseJson = await fetchJson('cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ items: nestedAddOnItems, ...sectionRequest })
              });
              addedItems.push(...(Array.isArray(responseJson.items) ? responseJson.items : [responseJson]));
            } else {
              formData.set('sections', sectionsToBundle.join(','));
              formData.set('sections_url', sectionRequest.sections_url);
              responseJson = await fetchJson('cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: formData
              });
              addedItems = Array.isArray(responseJson.items) ? responseJson.items : [responseJson];
            }
          } catch (error) {
            if (bundleId) await removeBundleFromCart(bundleId);
            throw error;
          }

          const themeSettings = window.themeVariables && window.themeVariables.settings
            ? window.themeVariables.settings
            : {};
          if (themeSettings.cartType === 'page' || themeSettings.pageType === 'cart') {
            window.location.assign(`${normalizedRoutesRoot()}cart`);
            return true;
          }

          try {
            const renderedSections = responseJson && responseJson.sections;
            const sectionsComplete = renderedSections && sectionsToBundle.every((sectionId) => (
              Object.prototype.hasOwnProperty.call(renderedSections, sectionId)
              && renderedSections[sectionId] !== null
            ));
            if (!sectionsComplete) {
              window.location.assign(`${normalizedRoutesRoot()}cart`);
              return true;
            }
            const cartContent = await fetchJson('cart.js');
            cartContent.sections = renderedSections;
            activeForm.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: addedItems, cart: cartContent }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            }));
          } catch (refreshError) {
            window.location.assign(`${normalizedRoutesRoot()}cart`);
            return true;
          }
          return false;
        };

        const handleFormSubmit = (event) => {
          const activeForm = event.currentTarget;
          if (activeForm !== findPrimaryForm()) return;
          if (noFieldsRequired || (customizerState !== 'configured' && !hardBlockReason)) return;
          form = activeForm;
          updateVariantStateFromForm(activeForm);
          captureCustomizationState();
          if (replacesLegacyOptions) {
            legacyGpoScope.querySelectorAll('.gpo-app input, .gpo-app select, .gpo-app textarea, .gpo-hidden-inputs input, .gpo-hidden-inputs select, .gpo-hidden-inputs textarea, [name="properties[_has_gpo]"]').forEach((control) => {
              control.required = false;
              control.disabled = true;
              control.removeAttribute('form');
            });
          }
          updateConditionalVariantFields();
          applyConfiguredConditions();
          updatePaidOptionState();
          if (submissionInProgress || paidPricingPending || hardBlockReason) {
            event.preventDefault();
            event.stopImmediatePropagation();
            enforceHardBlock();
            return;
          }
          const invalidField = Array.from(root.querySelectorAll('input, select, textarea')).find((field) => !field.disabled && !field.checkValidity());
          if (invalidField) {
            event.preventDefault();
            event.stopImmediatePropagation();
            root.classList.add('br-native-customizer--invalid');
            invalidField.reportValidity();
            root.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (selectedCustomizationFiles().length > 2) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showActionError('Upload no more than two files for one product configuration.');
            root.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          root.classList.remove('br-native-customizer--invalid');
          let addOns = [];
          try { addOns = selectedAddOns(); }
          catch (error) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showActionError(error.message);
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          showActionError('');
          setBusy(true);
          addConfiguredBundle(addOns, activeForm)
            .then((navigating) => {
              if (!navigating) setBusy(false);
            })
            .catch((error) => {
              showActionError(`${error.message} Nothing from this attempt should remain in the cart. Please try again or contact us.`);
              setBusy(false);
            });
        };

        let formListenerController = null;
        let boundForm = null;
        const handleProductRerender = () => scheduleEnvironmentSync();
        const bindCurrentForm = () => {
          const activeForm = findPrimaryForm();
          if (!activeForm || activeForm === boundForm) return;
          if (formListenerController) formListenerController.abort();
          form = activeForm;
          boundForm = activeForm;
          formListenerController = new AbortController();
          activeForm.addEventListener('change', handleFormChange, { signal: formListenerController.signal });
          activeForm.addEventListener('variant:change', handleVariantChange, { signal: formListenerController.signal });
          activeForm.addEventListener('product:rerender', handleProductRerender, { signal: formListenerController.signal });
          activeForm.addEventListener('submit', handleFormSubmit, { capture: true, signal: formListenerController.signal });
          Array.from(activeForm.elements)
            .filter((field) => field && field.name === 'quantity')
            .forEach((field) => {
              field.addEventListener('input', updatePaidOptionState, { signal: formListenerController.signal });
              field.addEventListener('change', updatePaidOptionState, { signal: formListenerController.signal });
            });
        };

        let environmentSyncQueued = false;
        const syncEnvironment = () => {
          environmentSyncQueued = false;
          if (!root.isConnected || !ensureStableMount()) return;
          bindCurrentForm();
          updateVariantStateFromForm(form);
          restoreCustomizationState();
          updateConditionalVariantFields();
          applyConfiguredConditions();
          updatePaidOptionState();
          enforceConfiguredFormState();
          enforceHardBlock();
        };
        scheduleEnvironmentSync = () => {
          if (environmentSyncQueued) return;
          environmentSyncQueued = true;
          window.queueMicrotask(syncEnvironment);
        };

        bindCurrentForm();
        const lifecycleObserver = new MutationObserver(scheduleEnvironmentSync);
        lifecycleObserver.observe(productInfo || form, { childList: true, subtree: true });
        root.brLifecycleObserver = lifecycleObserver;

        const releasePurchaseGates = () => {
          purchaseButtons().forEach((button) => {
            if (button.dataset.brPricingGate === 'true') {
              button.disabled = button.dataset.brPricingWasDisabled === 'true';
              if (!button.disabled) button.removeAttribute('aria-disabled');
            }
            delete button.dataset.brPricingWasDisabled;
            delete button.dataset.brPricingGate;
            delete button.dataset.brHardBlocked;
          });
        };
        const teardown = ({ preserveRoot }) => {
          captureCustomizationState();
          lifecycleObserver.disconnect();
          if (root.brLegacyObserver) root.brLegacyObserver.disconnect();
          if (root.brFormObserver) root.brFormObserver.disconnect();
          if (formListenerController) formListenerController.abort();
          releasePurchaseGates();
          lifecycleAbortController.abort();
          delete root.brLifecycleObserver;
          delete root.brLegacyObserver;
          delete root.brFormObserver;
          delete root.brLifecycleAbortController;
          delete root.dataset.brInitialized;
          delete root.dataset.brRetryCount;
          if (preserveRoot && ownerSection && ownerSection.isConnected) {
            ownerSection.appendChild(root);
            root.hidden = true;
          } else {
            root.remove();
          }
        };
        document.addEventListener('shopify:section:unload', (event) => {
          const target = event.target;
          const ownerUnloading = target === ownerSection || (ownerSectionId && target.id === ownerSectionId);
          const mainUnloading = target === mainSection || (!ownerUnloading && target.contains(root));
          if (!ownerUnloading && !mainUnloading) return;
          teardown({ preserveRoot: mainUnloading && !ownerUnloading });
        }, { signal: lifecycleSignal });

        enforceHardBlock();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-page-shell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-br-membership-app]');
    if (!root) return;
    const replacements = new Map([
      ['Get Rewards By Your purchase', 'BornReal Membership'],
      ['Turn loyal customers into members with exclusive perks and recurring rewards', 'Choose a plan that matches the materials you collect and the benefits you will actually use.'],
      ['Custom place order reward', 'Points on eligible orders'],
      ['Custom birthday gift', 'Birthday benefit'],
      ['General discount', 'Member discount'],
      ['Custom: Free re-plating service', 'Complimentary re-plating'],
      ['Custom: Material buyback', 'Material buyback service'],
      ['Buy Plan', 'Choose this plan']
    ]);
    const normalize = () => {
      root.querySelectorAll('*').forEach((element) => {
        if (element.children.length) return;
        const current = element.textContent.trim();
        if (replacements.has(current)) element.textContent = replacements.get(current);
        if (current.includes('$29.99/yr')) element.textContent = current.replace('$29.99/yr', '$29.90/yr');
        if (current.includes('$99.99/yr')) element.textContent = current.replace('$99.99/yr', '$99.90/yr');
      });
    };
    normalize();
    new MutationObserver(normalize).observe(root, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
